import React from 'react'
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux'
import useAuth from '../../../../features/hooks/useAuth'
import { useGetassetReqQuery, useUpdateassetReqstatusMutation, useUpdateassetReqFinalMutation } from '../../../../features/assetrequest/assetReqApiSlice'
import { useGetUsersQuery, useAddUserAssetsMutation, useHandoverOffTranAssetsMutation } from '../../../../features/users/usersApiSlice';
import { useUpdateAssetintransitMutation } from '../../../../features/addassets/addassetfinalApiSlice'
import Select from 'react-select';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { useAddNewassetTransMutation, useGetassetTransQuery, useUpdateassetTransMutation } from '../../../../features/assetTransApiSlice/assetTransApiSlice'
import { useGetofficeTransQuery, useAddNewofficeTransMutation, useUpdateofficeTransMutation } from '../../../../features/assetTransApiSlice/officeTransApiSlice'
import EnhancedTable from './UOfcAssetTransFormTable'
import ReactTooltip from "react-tooltip";
import { useGetofficesQuery } from '../../../../features/offices/officesApiSlice';
import { useAddNewTransactionMutation } from '../../../../features/transactions/transactionsApiSlice';
import { HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, RequestClosureWarapperAccepted, RequestClosureWarapperRejected, AddRemarkButton, BackButtonSpan } from '../../../../Styles/CommonStyles'


const Container = styled.div``
const Wrapper = styled.div`
display: flex;
flex-direction: column;
`
const ReqWrapper = styled.div``

const AssetItemsWrap = styled.span`
margin-right: 30px;
font-size: 20px;
`
const TextWrapper = styled.div`
font-size: 20px;
`
const UserNameContainer = styled.div`
padding-right: 30px;
font-size: 20px;
`
const PreDataCont = styled.div`
`
const FormContainer = styled.div``
const FormWrapper = styled.div``
const AssetFormContainer = styled.div`
`
const AssetFormWrapper = styled.div``
const TextFormCont = styled.div``

const FormItemsCont = styled.div`
display: flex;
align-items: center;
`
const InputFieldWrap = styled.div``
const SelectContainer = styled.div`
display: flex;
align-items: center;
`
const Option = styled.option`
font-weight: 100;
`
const Styledlabel = styled.label`
font-size: 20px;
font-weight: 200;
`
const CatSelect = styled.select`
width: 30%;
height: 35px;
`
const SubcatSelect = styled.select`
width: 30%;
height: 30px;
`
const ButtonContainer = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`

const TimeAndNameCont = styled.div`
display: flex;
font-size: 20px;
justify-content: space-between;
`
const TimeWrapper = styled.div`
font-size: 20px;
`
const NoteCountCont = styled.div`
font-size: 22px;
font-weight: 600;
`
const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`
const StoreNameCont = styled.div`
font-size: 20px;
align-self: center;
`
const AcceptAssetsButton = styled(CommonButton)``
const RejectAssetsButton = styled(CommonButton)`
background-color: #e65733;
`

const OldAssetsCont = styled.div``
const OldAssetWrapper = styled.div`
display: flex;
`
const OldItemsWrapper = styled.div`
display: flex;
margin-right: 40px;
margin-bottom: 20px;`

const UOfcAssetTransForm = ({ reqid, setChangepage }) => {

  const [content, setContent] = useState('');
  const [remarkButtonClicked, setRemarkButtonClicked] = useState(false)
  const editor = useRef(null);
  const [savedAssetsinDb, setSavedAssetsinDb] = useState([])
  const [reqStatus, setRequestStatus] = useState('')

  //logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]

  //Single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })

  //call single user data of the user logged in
  let singleUser_data = getSingleuser && getSingleuser[id]

  //Single Request call
  const { getSingleRequest } = useGetassetReqQuery('allassetReqlist', {
    selectFromResult: ({ data }) => ({
      getSingleRequest: data?.entities
    }),
  })

  const getCurrentDateISO = () => {
    const today = new Date();
    return today;
  }

  //call the req doc which is clicked
  let singleReq_data = getSingleRequest && getSingleRequest[reqid]

  // handing over assets details
  let handoverAssetsIdsArray = singleReq_data?.req_data[0].assets_details

  // NOT REQUIRED
  // assets which were in non-trasit at the time of request
  let nontransitassets = singleReq_data?.req_data[0].non_transit_assets

  useEffect(() => {
    setSavedAssetsinDb(handoverAssetsIdsArray)
  }, [])

  //all office call
  const {
    data: allofficedata,
    isLoading: allofficeLoad,
  } = useGetofficesQuery('officelist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  let tempallofficedata = allofficedata ? Object.values(allofficedata?.entities) : []
  const officedata = tempallofficedata
  //sent to BO by user logic
  let useroffice = officedata?.filter(elm => elm.name === user_current_office)
  let Bo_id = useroffice[0]?.Bo

  //reqStatus Update Mutation
  const [updateReqStatus, { isLoading: updateaddassetreqStatusloading }] = useUpdateassetReqstatusMutation()

  //update Userboassets  Call
  const [updateBoAssets, { isLoading: addUserassetloading }] = useHandoverOffTranAssetsMutation()

  //update assets in transit
  const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()

  // transaction 
  const [addTrans, { isLoading: addTransloading }] = useAddNewTransactionMutation()

  // Object of request creator
  let reqCreatorObj = singleReq_data?.req_creator

  // asset transaction body logic. All the assets which are being transacted
  //all assets_trans call 
  const transacData = {
    transac_id: singleReq_data?.uniqueReqId,
    req_id: "",
    asset_id: handoverAssetsIdsArray,
    transac_type: 'botransfer',
    indi_asset: false,
    from_userid: getSingleuser?.[reqCreatorObj?.id]?.email || reqCreatorObj?.email,
    from_office: reqCreatorObj?.office,
    from_desig: reqCreatorObj?.designation,
    from_store: "",
    to_userid: email,
    to_office: user_current_office,
    to_desig: designation[user_current_office],
    to_store: "",
    pdfPath: "",
    time_stamp: getCurrentDateISO()
  }

  //body to be updated in asset recieving user collection
  let userUpdateBody = { id: id, bo_assets: true }

  // body to be updated in bo user
  let boUpdateBody = { id: singleReq_data?.req_creator.id, bo_assets: false }

  //update asset request final update for acceptance and rejection
  const [updateassetReqfinal, { isLoading: updateassetReqFinalloading }] = useUpdateassetReqFinalMutation()

  //#############################// accept handler //#################################
  //update status body for accept and insert closure time stamp
  let acceptReqObj = {
    curr_status: "accepted",
    close_time_stamp: new Date()
  }

  // update req also to keep time stamp of acceptance for closure
  let updatReqAcceptBody = { id: reqid, finalReqObj: acceptReqObj }

  // accept handler
  //update status body for reject
  let finalnontransitbody = { selectedAssetarray: nontransitassets, transtatus: false }

  const acceptHandler = async () => {
    try {
      //asset transaction logic
      await addTrans(transacData)
      //status of request to be accepted and closure timestamp
      await updateassetReqfinal(updatReqAcceptBody)
      //update user who is being allocated the asssets
      await updateBoAssets(userUpdateBody)
      //update bo who is handing over assets
      await updateBoAssets(boUpdateBody)
      //update assets in non-Transit
      await updateAssetinTran(finalnontransitbody)
      setChangepage([true, false, false, false, false])
      return alert('Assets accepted and this request is closed')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  //#############################// reject handler//######################
  let rejectReqObj = {
    curr_status: "rejected",
    close_time_stamp: new Date()
  }
  // update req also to keep time stamp of acceptance for closure
  let updatReqRejectBody = { id: reqid, finalReqObj: rejectReqObj }

  //reject handler
  const rejectHandler = async () => {
    try {
      await updateassetReqfinal(updatReqRejectBody)
      await updateAssetinTran(finalnontransitbody)
      setChangepage([true, false, false, false, false])
      return alert('Assets rejected and this request is closed')
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }


  return (
    <Container>
      <BackArrowContainer onClick={() => setChangepage([true, false, false, false, false])}><ArrowLeftIcon /><BackButtonSpan >Back to Category Table</BackButtonSpan></BackArrowContainer>
      {(singleReq_data?.curr_status !== 'rejected') && (singleReq_data?.curr_status !== 'accepted') && <AddRemarkButton onClick={() => setRemarkButtonClicked(true)}>Add Remark</AddRemarkButton>}
      <Wrapper>
        <ReqWrapper>
          <HeadingWrap>
            <Span>Request category: Office Assets Transfer (by BO)</Span>
          </HeadingWrap>
          <PreDataCont>
            {getSingleRequest[reqid]?.req_data.map((elm, ind) =>
              <PreDataWrap key={ind}>
                <HeadingWrap>
                  <NoteCountCont>Note-{ind + 1}</NoteCountCont>
                </HeadingWrap>
                {elm.assets_details && <div style={{ margin: '15px' }}><span style={{ fontSize: '20px' }}>Requested Asset Details (selected in the checkbox):</span></div>}
                {elm.assets_details && <EnhancedTable intSelectedAssets={elm?.assets_details} />}
                <TextWrapper>
                  Remark: <div dangerouslySetInnerHTML={{ __html: elm.Text }} />
                </TextWrapper>
                <TimeAndNameCont>
                  <TimeWrapper>
                    {getSingleRequest[reqid]?.req_data[getSingleRequest[reqid]?.req_data.length - 1].time_stamp}
                  </TimeWrapper>
                  <UserNameContainer>
                    {`${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.firstName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.middleName} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.name?.lastName}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.office}-${getSingleRequest[reqid]?.req_data[ind].sent_by?.designation} ${getSingleRequest[reqid]?.req_data[ind].sent_by?.designationSuffix}`}
                  </UserNameContainer>
                </TimeAndNameCont>
              </PreDataWrap>)}
          </PreDataCont>
        </ReqWrapper>
        {remarkButtonClicked && <ButtonContainer>
          {<AcceptAssetsButton onClick={acceptHandler}> Accept Assets </AcceptAssetsButton>}
          {<RejectAssetsButton onClick={rejectHandler}>Reject Assets</RejectAssetsButton>}
        </ButtonContainer>}

        {/* request Closure logic */}
        {(singleReq_data?.curr_status === 'accepted') && <RequestClosureWarapperAccepted>This Request has been closed. The assets has been accepted by  {`${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data.name?.lastName}-${user_current_office}-${singleUser_data?.designation[user_current_office]} ${singleUser_data?.designationSuffix[user_current_office]}`} </RequestClosureWarapperAccepted>}
        {(singleReq_data?.curr_status === 'rejected') && <RequestClosureWarapperRejected>This Request has been closed. The assets has been rejected by {`${singleUser_data?.name?.firstName} ${singleUser_data?.name?.middleName} ${singleUser_data.name?.lastName}-${user_current_office}-${singleUser_data?.designation[user_current_office]} ${singleUser_data?.designationSuffix[user_current_office]}`}   </RequestClosureWarapperRejected>}
      </Wrapper>
    </Container>
  )
}

export default UOfcAssetTransForm